import { DirectionsRenderer } from "@react-google-maps/api"
import React from "react"
export default function RenderDirection({ response }) {
  return (
    <>
      {response && (
        <DirectionsRenderer
          onDirectionsChanged={e => {}}
          // required
          options={{
            directions: response,
            suppressMarkers: true,
            polylineOptions: {
              strokeColor: "#FF7F7F",
            },
          }}
        />
      )}
    </>
  )
}
